import {
  setStorageItem,
  getStorageItem,
  removeStorageItem,
  hasStorageItem,
  getStorageItemInfo,
  clearAllStorage,
  clearAppStorage,
  getStorageInfo
} from './localStorage';
import {
  savePokemonSelectPageData,
  loadPokemonSelectPageData,
  removePokemonSelectPageData,
  hasPokemonSelectPageData,
  getPokemonSelectPageDataInfo,
  updatePokemonSelectPageData,
  saveOffencePokemonList,
  loadOffencePokemonList,
  removeOffencePokemonList,
  hasOffencePokemonList,
  saveDefencePokemon,
  loadDefencePokemon,
  removeDefencePokemon,
  hasDefencePokemon,
  saveDefencePokemonList,
  loadDefencePokemonList,
  removeDefencePokemonList,
  hasDefencePokemonList,
  saveAttackPokemonList,
  loadAttackPokemonList,
  saveComprehensiveOpponentList,
  loadComprehensiveOpponentList,
  removeComprehensiveOpponentList,
  hasComprehensiveOpponentList,
  removeAllPokemonData,
  loadDamageSettingUiState,
  updateDamageSettingUiState,
  removeDamageSettingUiState
} from './pokemonStorage';

// 型定義のエクスポート
export type {
  PokemonSelectPageData,
  OffencePokemonListData,
  DefencePokemonData,
  DefencePokemonListData,
  ComprehensiveOpponentListData,
  StorageValue,
  StorageKey,
  StorageResult,
  StorageError,
  StorageSuccess,
  SavedDataInfo
} from './types';

export { STORAGE_KEYS } from './types';

/**
 * localStorage の低レベルAPIをまとめた名前空間。
 * UI層ではこのオブジェクト越しに直接操作し、生の関数を増やさない。
 */
const localStorageClient = {
  setItem: setStorageItem,
  getItem: getStorageItem,
  removeItem: removeStorageItem,
  hasItem: hasStorageItem,
  getItemInfo: getStorageItemInfo,
  clearAll: clearAllStorage,
  clearApp: clearAppStorage,
  getInfo: getStorageInfo
} as const;

/**
 * ポケモン関連の永続化API群。
 * 各データ種別ごとに責務を明示して重複関数をなくす。
 */
const pokemonStorageClient = {
  selectPage: {
    save: savePokemonSelectPageData,
    load: loadPokemonSelectPageData,
    remove: removePokemonSelectPageData,
    has: hasPokemonSelectPageData,
    info: getPokemonSelectPageDataInfo,
    update: updatePokemonSelectPageData
  },
  offenceList: {
    save: saveOffencePokemonList,
    load: loadOffencePokemonList,
    remove: removeOffencePokemonList,
    has: hasOffencePokemonList
  },
  defencePokemon: {
    save: saveDefencePokemon,
    load: loadDefencePokemon,
    remove: removeDefencePokemon,
    has: hasDefencePokemon
  },
  defenceList: {
    save: saveDefencePokemonList,
    load: loadDefencePokemonList,
    remove: removeDefencePokemonList,
    has: hasDefencePokemonList
  },
  attackList: {
    save: saveAttackPokemonList,
    load: loadAttackPokemonList
  },
  comprehensiveList: {
    save: saveComprehensiveOpponentList,
    load: loadComprehensiveOpponentList,
    remove: removeComprehensiveOpponentList,
    has: hasComprehensiveOpponentList,
  },
  damageSettingUi: {
    load: loadDamageSettingUiState,
    update: updateDamageSettingUiState,
    remove: removeDamageSettingUiState,
  },
  removeAll: removeAllPokemonData
} as const;

/**
 * ストレージ操作の公開エントリポイント。
 * local / pokemon を統一した一つのAPIとして露出する。
 */
export const storageClient = {
  local: localStorageClient,
  pokemon: pokemonStorageClient
} as const;

export type LocalStorageClient = typeof storageClient['local'];
export type PokemonStorageClient = typeof storageClient['pokemon'];
export type StorageClient = typeof storageClient;
